class CustomDate {
  constructor ({ id, description, from, to }) {
    this.id = id
    this.description = description
    this.from = from ? new Date(from) : null
    this.to = to ? new Date(to) : null
  }
}

class DynamicDateOption {
  constructor ({ id, value, from, to, selected, granularity }) {
    this.id = id
    this.value = value
    this.from = from ? new Date(from) : null
    this.to = to ? new Date(to) : null
    this.selected = selected
    this.granularity = granularity
  }
}

class DynamicDate {
  constructor ({ id, description, selected, options }) {
    this.id = id
    this.description = description
    this.selected = selected
    this.options = options.map(option => new DynamicDateOption(option))
  }
}

class DateSelection {
  constructor ({ dynamicDate, customDate }) {
    this.dynamicDate = new DynamicDate(dynamicDate)
    this.customDate = new CustomDate(customDate)
  }
}

export default DateSelection



// WEBPACK FOOTER //
// ./src/app/massive_download/models/DateSelection.js